import { EditOutlined, GroupOutlined, InfoOutlined, KeyboardArrowDown } from '@mui/icons-material'
import {
  Box,
  Button,
  Checkbox,
  IconButton,
  Link,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material'
import type { SupplierRow, SupplierTab } from './SupplierList.types'

export interface SupplierTableProps {
  rows: SupplierRow[]
  activeTab: SupplierTab
  onEditSupplier: (id: number) => void
  onOpenAuthorizedOem: (rowId: number) => void
  onOpenNotes: (rowId: number) => void
  onApprove: (row: SupplierRow) => void
  onBlanketChange: (id: number, checked: boolean) => void
}

export function SupplierTable({
  rows,
  activeTab,
  onEditSupplier,
  onOpenAuthorizedOem,
  onOpenNotes,
  onApprove,
  onBlanketChange,
}: SupplierTableProps) {
  return (
    <Table stickyHeader>
      <TableHead>
        <TableRow>
          <TableCell width="22%">Name</TableCell>
          <TableCell width="20%">Type</TableCell>
          <TableCell width="16%">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              Blanket <InfoOutlined fontSize="small" />
            </Box>
          </TableCell>
          <TableCell width="18%">Documents</TableCell>
          <TableCell width="14%">Authorized OEM</TableCell>
          <TableCell width="10%" align="right">
            Notes
          </TableCell>
          {activeTab === 'pending' && <TableCell width="12%" align="right"></TableCell>}
        </TableRow>
      </TableHead>

      <TableBody>
        {rows.map((row: SupplierRow) => (
          <TableRow key={row.id} hover>
            <TableCell>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Link component="button" onClick={() => onEditSupplier(row.id)}>
                  {row.name}
                </Link>
                <IconButton size="small">
                  <KeyboardArrowDown />
                </IconButton>
              </Box>
            </TableCell>

            <TableCell>{row.type}</TableCell>

            <TableCell>
              <Checkbox checked={row.blanket} onChange={e => onBlanketChange(row.id, e.target.checked)} />
            </TableCell>

            <TableCell>
              <Link href={row.documentsUrl} target="_blank" rel="noopener noreferrer">
                {row.documentsLabel}
              </Link>
            </TableCell>

            <TableCell>
              <IconButton aria-label="Open authorized OEM" onClick={() => onOpenAuthorizedOem(row.id)}>
                <GroupOutlined />
              </IconButton>
            </TableCell>

            <TableCell align="right">
              <IconButton aria-label="Open notes" onClick={() => onOpenNotes(row.id)}>
                <EditOutlined />
              </IconButton>
            </TableCell>

            {activeTab === 'pending' && (
              <TableCell align="right">
                <Button
                  variant="outlined"
                  size="small"
                  onClick={e => {
                    e.preventDefault()
                    e.stopPropagation()
                    onApprove(row)
                  }}
                >
                  APPROVE
                </Button>
              </TableCell>
            )}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
